// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1RFOd","title":"ClientInsurance_title__2ISpW","itemText":"ClientInsurance_itemText__3FAor"};